















import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import InputFileMixin from "@scrile/tools/vue/mixin/InputFileMixin";
import { getNameMimeType } from "@/lib/fileHelpers";
import config from "@/config";

const inputFileMixin = InputFileMixin(config.fileTypes);

@Component({
  name: "BaseInputFile",
})
export default class BaseInputFile extends mixins(inputFileMixin) {
  @Prop({ type: Boolean, default: false })
  public readonly multiple!: boolean;

  @Prop({ default: null })
  public readonly files!: FileList | null;

  @Prop({ type: Boolean, default: false })
  public readonly showUploader!: boolean;

  public showFileUpload() {
    const input = this.$refs.input;
    if (input instanceof HTMLInputElement) {
      input.value = "";
      input.click();
    }
  }

  public selectFile(e: Event) {
    e.stopPropagation();
    const element = e.target as HTMLInputElement;
    const files = element.files
      ? Array.from(element.files).filter(f => {
          let type = getNameMimeType(f.name);
          return !this.accept || (type && this.acceptTypes.includes(type));
        })
      : [];
    if (files.length > 0) {
      this.$emit("input", files);
      if (this.files === null) (this.$refs.input as HTMLInputElement).value = "";
    }
  }

  @Watch("files")
  public clearInput(newValue: FileList | null) {
    if (newValue === null) (this.$refs.input as HTMLInputElement).value = "";
  }

  @Watch("showUploader")
  public showUploaderWatcher(newValue: boolean | null) {
    if (newValue) this.showFileUpload();
  }
}
